import React from "react";
import { Button } from "@mui/material";
import { PlusIcon } from "assets";

interface AddTargetButtonProps {
    onToggleAddTargetModal: () => void;
}

export const AddTargetButton = ({ onToggleAddTargetModal }: AddTargetButtonProps) => {
    const onAddTargetButtonClick = () => {
        onToggleAddTargetModal();
    };

    return (
        <Button
            sx={{ width: 'fit-content', padding: '6px 17px', height: '36px', borderRadius: 2 }}
            variant="contained"
            onClick={onAddTargetButtonClick}
            startIcon={<PlusIcon />}
            aria-label="Add target"
        >
            Add Target
        </Button>
    );
};